import React, { useState, useEffect } from 'react';
import '../App.css';
import { useLocation } from 'react-router-dom';
import LoaderImg from '../img/logo/running.gif';
import axios from '../axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventSucessPopup from "../Create_event_details/EventSucessPopup";
import { redirect } from 'react-router-dom';

const Settings = (props) => {
  //console.log(props.EventData);
  const { state } = useLocation();
  const EditEventId = state ? state.eventId : 0;
  const [NoOfPreviousConducts, setNoOfPreviousConducts] = useState(0);
  const [NoOfRunnersEstimate, setNoOfRunnersEstimate] = useState(0);
  const [NoOfEventYear, setNoOfEventYear] = useState(0);
  const [YtcrBaseTicketPrice, setYtcrBaseTicketPrice] = useState('0.00');
  const [YtcrBasePrice, setYtcrBasePrice] = useState(props.YtcrFeePercent);

  const [ContractOfFiveYear, setContractOfFiveYear] = useState(false);
  const [BackendSupport, setBackendSupport] = useState(false);
  const [BulkRegistration, setBulkRegistration] = useState(false);
  const [CheckValidEntries, setCheckValidEntries] = useState(false);
  const [Loader, setLoader] = useState(false);
  const [CalculatedFlag, setCalculatedFlag] = useState(true);

  const [EventSettingId, setEventSettingId] = useState(0);
  const EventSettingDetails = props.EventData !== '' ? props.EventData : '';
  // const CategoriesAll = props.CategoriesAll !== '' ? props.CategoriesAll : '';
  // console.log(CategoriesAll);

  const [PaymentStatus, setPaymentStatus] = useState(1);
  const [TestPayStatus, setTestPayStatus] = useState('active');
  const [LivePayStatus, setLivePayStatus] = useState('');

  const [CategoriesStatus, setCategoriesStatus] = useState(0);
  const [No, setNo] = useState('active');
  const [Yes, setYes] = useState('');
  const [CategoriesAdd, setCategoriesAdd] = useState(false);
  const [AddCategories, setAddCategories] = useState('');
  const [AddCategoriesError, setAddCategoriesError] = useState('');

  //--------------- new

  const [OverallLimit, setOverallLimit] = useState('');
  const [EventRegistrationStatus, setEventRegistrationStatus] = useState(2);
  const [SingleStatus, setSingleStatus] = useState('');
  const [MultipleStatus, setMultipleStatus] = useState('active');
  const [AllowUniqueRegistration, setAllowUniqueRegistration] = useState(false);
  const [FeaturedEvent, setFeaturedEvent] = useState(false);
  const [TestMerchantKey, setTestMerchantKey] = useState('');
  const [TestSalt, setTestSalt] = useState('');
  const [TestRedirectionUrl, setTestRedirectionUrl] = useState('');

  const [LiveMerchantKey, setLiveMerchantKey] = useState('');
  const [LiveSalt, setLiveSalt] = useState('');
  const [LiveRedirectionUrl, setLiveRedirectionUrl] = useState('');

  const [OverallLimitError, setOverallLimitError] = useState('');
  const [CategoriesAll, setCategoriesAll] = useState([]);
  const [CategoriesError, setCategoriesError] = useState('');

  const handleCategoryChange = (index, evnt) => {

    let CategoriesAll1 = [...CategoriesAll];
    CategoriesAll1[index]['checked'] = evnt.target.checked;
    setCategoriesAll(CategoriesAll1);
    // console.log(CategoriesAll);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    if (EventSettingDetails) {
      // console.log(EventSettingDetails);

      setOverallLimit(EventSettingDetails.overall_limit ? EventSettingDetails.overall_limit : '');
      setAllowUniqueRegistration(EventSettingDetails.allow_unique_registration === 1 ? true : false);
      setFeaturedEvent(EventSettingDetails.featured_events === 1 ? true : false);
      
      setEventRegistrationStatus(EventSettingDetails.event_registration_status);

      if (EventSettingDetails.event_registration_status === 2) {
        setMultipleStatus('active'); setSingleStatus('');
      } else {
        setMultipleStatus(''); setSingleStatus('active');
      }

      setTestMerchantKey(EventSettingDetails.test_pay_merchant_key ? EventSettingDetails.test_pay_merchant_key : '');
      setTestSalt(EventSettingDetails.test_pay_salt ? EventSettingDetails.test_pay_salt : '');
      setTestRedirectionUrl(EventSettingDetails.test_pay_redirection_url ? EventSettingDetails.test_pay_redirection_url : '');

      if (EventSettingDetails.is_live_pay_status === 2) {
        setLivePayStatus('active'); setTestPayStatus('');
      } else {
        setLivePayStatus(''); setTestPayStatus('active');
      }

      setCategoriesStatus(EventSettingDetails.categories_status);
      if (EventSettingDetails.categories_status === 1) {
        setYes('active'); setNo('');
      } else {
        setYes(''); setNo('active');
      }

      setLiveMerchantKey(EventSettingDetails.live_pay_merchant_key ? EventSettingDetails.live_pay_merchant_key : '');
      setLiveSalt(EventSettingDetails.live_pay_salt ? EventSettingDetails.live_pay_salt : '');
      setLiveRedirectionUrl(EventSettingDetails.live_pay_redirection_url ? EventSettingDetails.live_pay_redirection_url : '');
      setPaymentStatus(EventSettingDetails.is_live_pay_status ? EventSettingDetails.is_live_pay_status : 1);

      setCategoriesAll(props.CategoriesAll !== '' ? props.CategoriesAll : '');
    }
  }, [EventSettingDetails])

  const handleValidation = () => {
    // console.log(OverallLimit);
    var flag = true;

    if (OverallLimit == 0 && OverallLimit != '') {
      setOverallLimitError("Overall Limit Less than or equal to zero is not allowed");
      flag = false;
    } else {
      setOverallLimitError("");
    }

    const isValid = CategoriesAll.some(item => item.checked);
    if (!isValid && CategoriesStatus) {
      setCategoriesError("Please select at least one category!");
      flag = false;
    } else {
      setCategoriesError("");
    }

    return flag;
  }

  const handleSubmit = (e) => {

    e.preventDefault();
    const flag = handleValidation();
    if (flag) {
      setLoader(true);

      const jsonData = CategoriesAll ? JSON.stringify(CategoriesAll) : '';
      const payload = {
        module_name: "Event Settings",
        event_id: EditEventId ? EditEventId : 0,
        overall_limit: OverallLimit,
        allow_unique_registration: AllowUniqueRegistration === true ? 1 : 0,
        featured_event: FeaturedEvent === true ? 1 : 0,
        event_registration_status: EventRegistrationStatus,
        payment_status: PaymentStatus,
        // test_merchant_key: TestMerchantKey,
        // test_salt: TestSalt,
        // test_redirection_url: TestRedirectionUrl,
        // live_merchant_key: LiveMerchantKey,
        // live_salt: LiveSalt,
        // live_redirection_url: LiveRedirectionUrl,
        categories_status: CategoriesStatus,
        categories_selected_data: jsonData,
      };
      // console.log(payload);
      axios.post("event_setting", payload)
        .then((response) => {
          setLoader(false);
          // console.log(response.data);
          if (response.status === 200) {
            props.setEventResponceTabs(11);
            toast.success(response.data.message)
            //setsuccessMsg(response.data.message);
          }
        })
        .catch(() => {
          setLoader(false);
          console.log('error');
        });
    }
  };
  
  const handleValidation1 = () => {
    // console.log(OverallLimit);
    var flag = true;

    if (AddCategories === '') {
      setAddCategoriesError("Please enter category name");
      flag = false;
    } else {
      setAddCategoriesError("");
    }

    return flag;
  }

  const handleSubmit1 = (e) => {
    //  props.setEventApiCall(false);
    e.preventDefault();
    const flag = handleValidation1();
    if (flag) {
      setLoader(true);
      const payload = {
        event_id: EditEventId ? EditEventId : 0,
        categories_name: AddCategories,
      };
      // console.log(payload);
      axios.post("add_categories", payload)
        .then((response) => {
          // console.log(response.data.flag);
          setLoader(false);
          if (response.status === 200 && response.data.flag === 0) {
            // props.setEventResponceTabs(4);
            toast.success(response.data.message)
            setAddCategoriesError('');
            setCategoriesAdd(false);
            props.setEventSettingCategoryFlag(true);
          }else{
            toast.error(response.data.message);
            setAddCategoriesError(response.data.message)
          }
        })
        .catch(() => {
          setLoader(false);
          console.log('error');
        });
    }
  };

  useEffect(() => {

    if (CalculatedFlag) {
      //console.log('test');
      const ytcr_price = YtcrBasePrice;

      const no_of_previous_conducts = NoOfPreviousConducts !== '' && NoOfPreviousConducts !== '0' ? (NoOfPreviousConducts * ytcr_price) / 100 : 0;
      // console.log(no_of_previous_conducts);

      const no_of_runners_estimate = NoOfRunnersEstimate !== '' && NoOfRunnersEstimate !== '0' ? (NoOfRunnersEstimate * ytcr_price) / 100 : 0;

      const no_of_event_year = NoOfEventYear !== '' && NoOfEventYear !== '0' ? (NoOfEventYear * ytcr_price) / 100 : 0;

      const contract_of_five_year = ContractOfFiveYear === true ? (10 * ytcr_price) / 100 : 0;

      //------- extra add-on --------------
      const backend_support = BackendSupport === true ? (5 * ytcr_price) / 100 : 0;
      const bulk_registration = BulkRegistration === true ? (2 * ytcr_price) / 100 : 0;
      const check_valid_entries = CheckValidEntries === true ? (3 * ytcr_price) / 100 : 0;

      let final_ticket_ytcr_base_price = (ytcr_price - no_of_previous_conducts - no_of_runners_estimate - no_of_event_year - contract_of_five_year + backend_support + bulk_registration + check_valid_entries);

      setYtcrBaseTicketPrice(parseFloat(final_ticket_ytcr_base_price).toFixed(2));
      setCalculatedFlag(false);
    }

  }, [NoOfPreviousConducts, NoOfRunnersEstimate, NoOfEventYear, ContractOfFiveYear, BackendSupport, BulkRegistration, CheckValidEntries, CalculatedFlag]);

  return (
    <>

      {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}

      <div className="main checkout__mian">

        <form method="post" onSubmit={handleSubmit} >
          <div className="checkout__content--step section__shipping--address ">

            <div className="section__header checkout__section--header d-flex align-items-center justify-content-between mb-4">
              <h2 className="section__header--title h3">Event Settings</h2>
            </div>

          </div>

          <div className="row mb-3">

            <div className="col-sm-6 my-3 ">
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  value={OverallLimit}
                  onChange={(e) => { setOverallLimit(e.target.value.replace(/\D/g, '')) }}
                  maxLength={5}
                />
                <label>Overall Limit</label>
              </div>
              <small className="text-danger">{OverallLimitError}</small>
            </div>

            <div className="col-sm-6 my-3 d-flex align-items-center gap-4">
              <label className="">Registrations</label>
              <div className="ebi">
                <div className="event-visibility hand_cursor">
                  <div className={'visibility gap-1 ' + SingleStatus} onClick={() => { setEventRegistrationStatus(1); setSingleStatus('active'); setMultipleStatus(''); }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={20}
                      viewBox="0 -960 960 960"
                      width={20}
                    >
                      <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-82v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q20-22 36-47.5t26.5-53q10.5-27.5 16-56.5t5.5-59q0-98-54.5-179T600-776v16q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z" />
                    </svg>
                    Single
                  </div>

                  <div className={'visibility gap-1 ' + MultipleStatus} onClick={() => { setEventRegistrationStatus(2); setSingleStatus(''); setMultipleStatus('active'); }} >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={20}
                      viewBox="0 -960 960 960"
                      width={20}
                    >
                      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" />
                    </svg>
                    Multiple
                  </div>

                </div>
              </div>
            </div>

            <div className="col-lg-6 my-3 ">
              <div className="form-check form-switch d-flex align-items-left justify-content-left">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  value={AllowUniqueRegistration}
                  checked={AllowUniqueRegistration}
                  onChange={() => { setAllowUniqueRegistration(!AllowUniqueRegistration); }}
                />
                <label className="form-check-label">
                  Allow only unique registrations
                </label>
              </div>
            </div>

            <div className="col-lg-6 my-3 ">
              <div className="form-check form-switch d-flex align-items-left justify-content-left">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  value={FeaturedEvent}
                  checked={FeaturedEvent}
                  onChange={() => { setFeaturedEvent(!FeaturedEvent); }}
                />
                <label className="form-check-label">
                  Is Featured Event
                </label>
              </div>
            </div>

            {/* <h4 className="mb-3 ">Discounts:</h4> */}

            {/* <div className="col-sm-12">
                    <div className="form-floating mb-0">
                        
                      <select className="form-control" name="no_of_previous_conducts" value={NoOfPreviousConducts} onChange={(e) => { setNoOfPreviousConducts(e.target.value); setCalculatedFlag(true); }} > 
                       
                        <option value="0">1</option>
                        <option value="5">2</option>
                        <option value="7">3</option>
                        <option value="8">4</option>
                        <option value="10">5 or more than 5</option>
                      </select>

                      <label>Number of previously conducted editions</label>
                    </div>
                  </div>

                  <div className="col-sm-12 my-3 ">
                    <div className="form-floating mb-0">
                        
                      <select className="form-control" name="no_of_runners_estimate" value={NoOfRunnersEstimate} onChange={(e) => { setNoOfRunnersEstimate(e.target.value); setCalculatedFlag(true); }} > 
                        
                        <option value="0">0-1000</option>
                        <option value="10">1000-2000</option>
                        <option value="15">2000-3000</option>
                        <option value="20">3000-5000</option>
                        <option value="30">5000-7500</option>
                        <option value="40">7500 and above</option>
                      </select>

                      <label>Number of runners you estimate participate in your event</label>
                    </div>
                  </div>

                  <div className="col-sm-12 my-3 ">
                    <div className="form-floating mb-0">
                        
                      <select className="form-control" name="no_of_previous_conducts" value={NoOfEventYear} onChange={(e) => { setNoOfEventYear(e.target.value); setCalculatedFlag(true); }} > 
                       
                        <option value="0">1</option>
                        <option value="2">2</option>
                        <option value="4">3</option>
                        <option value="5">4 or more than 4</option>
                      </select>

                      <label>Number of other events you conduct each year</label>
                    </div>
                  </div>

                  <div className="col-lg-12 my-3 ">
                    <div className="form-check form-switch d-flex align-items-left justify-content-left">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        value={ContractOfFiveYear}
                        checked={ContractOfFiveYear}
                        onChange={() => { setContractOfFiveYear(!ContractOfFiveYear); setCalculatedFlag(true); }}
                      />
                      <label className="form-check-label">
                          Are you willing to enter into a contract of five years or more
                      </label>
                    </div>  
                  </div> */}

      {/* --------------------- Payment Gateway Settings ---------------------------- */}
            {/* <hr className="my-4" />
            <h4 className="mb-3 ">Payment Gateway Settings</h4>

            <div className="col-sm-6 my-3 d-flex align-items-center gap-4">
              <label className="">Payment Status</label>
              <div className="ebi">
                <div className="event-visibility hand_cursor">
                  <div className={'visibility gap-1 ' + TestPayStatus} onClick={() => { setPaymentStatus(1); setTestPayStatus('active'); setLivePayStatus(''); }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={20}
                      viewBox="0 -960 960 960"
                      width={20}
                    >
                      <path d="M240-320h320v-80H240v80Zm400 0h80v-80h-80v80ZM240-480h80v-80h-80v80Zm160 0h320v-80H400v80ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z" />
                    </svg>
                    Test
                  </div>

                  <div className={'visibility gap-1 ' + LivePayStatus} onClick={() => { setPaymentStatus(2); setTestPayStatus(''); setLivePayStatus('active'); }} >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={20}
                      viewBox="0 -960 960 960"
                      width={20}
                    >
                      <path d="m380-340 280-180-280-180v360Zm-60 220v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v480q0 33-23.5 56.5T800-200H640v80H320ZM160-280h640v-480H160v480Zm0 0v-480 480Z" />
                    </svg>
                    Live
                  </div>

                </div>
              </div>
            </div>

            {PaymentStatus === 1 ?
              <div>
                <div className="col-sm-6 my-3 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={TestMerchantKey}
                      onChange={(e) => { setTestMerchantKey(e.target.value) }}

                    />
                    <label>Test Merchant Key</label>
                  </div>
                </div>

                <div className="col-sm-6 my-3 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={TestSalt}
                      onChange={(e) => { setTestSalt(e.target.value) }}

                    />
                    <label>Test Salt</label>
                  </div>
                </div>

                <div className="col-sm-6 my-3 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={TestRedirectionUrl}
                      onChange={(e) => { setTestRedirectionUrl(e.target.value) }}

                    />
                    <label>Test Redirection URL</label>
                  </div>
                </div>
              </div>
              :
              <div>
                <div className="col-sm-6 my-3 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={LiveMerchantKey}
                      onChange={(e) => { setLiveMerchantKey(e.target.value) }}

                    />
                    <label>Live Merchant Key</label>
                  </div>
                </div>

                <div className="col-sm-6 my-3 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={LiveSalt}
                      onChange={(e) => { setLiveSalt(e.target.value) }}

                    />
                    <label>Live Salt</label>
                  </div>
                </div>

                <div className="col-sm-6 my-3 ">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      placeholder=""
                      value={LiveRedirectionUrl}
                      onChange={(e) => { setLiveRedirectionUrl(e.target.value) }}

                    />
                    <label>Live Redirection URL</label>
                  </div>
                </div>
              </div>
            } */}

            <hr className="my-4" />
            <h4 className="mb-3 ">Event Form Categories</h4>

            <div className="col-sm-6 my-3 d-flex align-items-center gap-4">
              <label className="">Add Scan Categories</label>
              <div className="ebi">
                <div className="event-visibility hand_cursor">
                  <div className={'visibility gap-1 ' + Yes} onClick={() => { setCategoriesStatus(1); setYes('active'); setNo(''); }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={20}
                      viewBox="0 -960 960 960"
                      width={20}
                    >
                      <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                    </svg>
                    Yes
                  </div>

                  <div className={'visibility gap-1 ' + No} onClick={() => { setCategoriesStatus(0); setYes(''); setNo('active'); }} >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height={20}
                      viewBox="0 -960 960 960"
                      width={20}
                    >
                      <path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                    </svg>
                    No
                  </div>

                </div>
              </div>
            </div>

            <div className="col-sm-6 my-3 d-flex align-items-center justify-content-end" style={{ float: 'right' }}>
              <div className="continue__shipping--btn secondary__btn border-radius-5" style={{ cursor: 'pointer' }} onClick={() => { setCategoriesAdd(true); setAddCategories(''); }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240ZZ" /></svg>
                Add Categories
              </div>
            </div>
          {/* {console.log(CategoriesAll)} */}
            {CategoriesAll && CategoriesAll.length > 0 ?
              CategoriesAll.map((item, index) => (
                <>

                  {CategoriesStatus == 1 ?
                    <div className="col-sm-6 my-3" key={index + '11'}>
                      <div className="plans">
                        <label className="plan basic-plan">
                          <input name="1"
                            type="checkbox"
                            className="btn-check"
                            value={item.checked}
                            defaultChecked={item.checked}
                            onClick={(evnt) => { handleCategoryChange(index, evnt); }}
                          />
                          <div className="plan-content">
                            <div className="plan-details" for='btn-check-outlined-1'>
                              <span className="h3 m-0"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M320-600q17 0 28.5-11.5T360-640q0-17-11.5-28.5T320-680q-17 0-28.5 11.5T280-640q0 17 11.5 28.5T320-600Zm0 160q17 0 28.5-11.5T360-480q0-17-11.5-28.5T320-520q-17 0-28.5 11.5T280-480q0 17 11.5 28.5T320-440Zm0 160q17 0 28.5-11.5T360-320q0-17-11.5-28.5T320-360q-17 0-28.5 11.5T280-320q0 17 11.5 28.5T320-280ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h440l200 200v440q0 33-23.5 56.5T760-120H200Zm0-80h560v-400H600v-160H200v560Zm0-560v160-160 560-560Z" /></svg> {item.name}</span>
                            </div>
                          </div>
                        </label>
                      </div>

                    </div>
                    : null}
                </>
              ))
              :

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 py-5 my-2 pb-0" >
                {/* <div className="w-100 not-avilable-card p-3 pb-4 d-flex flex-column align-items-center">
                        <img className=""  src={`${noCoupons}`} alt="" style={{ width: "130px" }} />
                        <p class="section__header--title h4 mb-3">No race categories avilable</p>
                        <p class="mb-4">No race categories to apply discounts. Please create an available race categories first</p>
                    </div> */}
              </div>

            }
            <small className="text-danger">{CategoriesError}</small>
          </div>

          <div className="checkout__content--step__footer d-flex align-items-center justify-content-end gap-4">
            <div className="continue__shipping--btn secondary__btn border-radius-5" onClick={(e) => { props.setEventResponceTabs(2) }} style={{ cursor: 'pointer' }}>Back</div>
            {/* <input type="button" name="command" value="Next (6/6)" className="continue__shipping--btn primary__btn border-radius-5"  /> */}
            <input type="submit" name="command" value="Save & Next (4/11)" className="continue__shipping--btn primary__btn border-radius-5" onClick={(e) => { props.setEventResponceTabs(4); }} />
          </div>
        </form>
      </div>

      {CategoriesAdd ?

        <div className="modal is-visible" data-animation="slideInUp">
          <div className="modal-dialog quickview__main--wrapper">
            {/* <header className="modal-header quickview__header">
                    <button className="close-modal quickview__close--btn" onClick={(e) => { setCategoriesAdd(false); }} >✕</button>
                  </header> */}
          <form method="post" onSubmit={handleSubmit1} encType="multipart/form-data" >
            <div className="quickview__inner">
              <h4 className="account__login--header__title mb-10">Add Categories</h4>
              <div className="row">

                <div className="form-floating mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    value={AddCategories}
                    onChange={(e) => { setAddCategories(e.target.value); }}
                  />
                  <label>Please enter category</label>
                  <small className="text-danger">{AddCategoriesError}</small>
                </div>
            
                <div className="d-flex gap-4 mt-2">
                  <button className="account__login--btn secondary__btn mt-2" onClick={() => { setCategoriesAdd(false); setAddCategoriesError(''); }}>Close</button>

                  <input type="submit" name="command" value="Save" className="account__login--btn primary__btn mt-2" />

                </div>

              </div>
            </div>
            </form>
          </div>

        </div>
        : null}

    </>
  )
}

export default Settings